import api from 'shared/api';
import { formatOrderBy } from 'shared/helpers';

// Same filters as the list, without paging, to select every order a search found
export const fetchMatchingOrders = (query, queryType, sortBy, filters, limit) => {
  const queryUrl = query ? `&${queryType}=${encodeURIComponent(query)}` : '';
  return api.get(
    `/api/v1/orders/?limit=${limit}&offset=0${queryUrl}${formatOrderBy(sortBy)}${filters}`,
  );
};
